import { Box } from '@/components/ui/lib/box';
import { DICTIONARY } from '@/config/dictionary';
import type { RouteProgressBarProps } from '@/app/types/route-progress-bar';
import '@/app/components/route-progress-bar.css';

/**
 * Indeterminate bar pinned to the top of the viewport while a route resolves.
 * The router leaves the outgoing page on screen for that whole wait, so this is
 * the only thing telling the user the click landed.
 */
const RouteProgressBar = ({ active }: RouteProgressBarProps) => {
  if (!active) {
    return null;
  }

  return (
    <Box
      className="route-progress-bar"
      role="progressbar"
      aria-busy="true"
      aria-label={DICTIONARY.common.loading}
    />
  );
};

export default RouteProgressBar;
